import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import targetingIconA from '../../img/targeting-icon-a.svg';
import billingIconA from '../../img/billing-icon-a.svg';
import volumeIcon from '../../img/volume.png';
import activateFeature from '../actions/ActivateFeature';
import getRecentMqlPlusLeads from '../actions/GetRecentMqlPlusLeads';
import purchaseLeads from '../actions/PurchaseLeads';
import CmsFooter from './CmsFooter';
import recentMqlPlusLeads from "../reducers/recent-mql-plus-leads";

class MqlPlusActivation extends React.Component {
  constructor(props) {
    super(props);

    let purchase = null;
    if (this.props.mqlPlusLeadCount === 0) {
      purchase = false;
    }

    this.state = {
      day: '',
      purchase,
      error: null,
    };

    this.onDayChange = this.onDayChange.bind(this);
    this.onPurchaseChange = this.onPurchaseChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
  }

  onDayChange(event) {
    this.setState({
      day: event.target.value,
      purchase: true,
    });

    this.refreshLeadDetails(event.target.value);
  }

  onPurchaseChange(purchase) {
    this.setState({
      purchase,
    });

    this.refreshLeadDetails();
  }

  onSubmit(event) {
    event.preventDefault();

    this.setError(null);

    if (this.state.purchase === null) {
      this.setError('Please choose whether to purchase recent leads or not to continue');
      return;
    }

    let requests = [this.props.activateFeature('mql-plus-leads')];

    if (this.state.purchase) {
      requests = [
        ...requests,
        this.props.purchaseLeads(this.state.day),
      ];
    }

    Promise.all(requests).then(() => {
      window.location.replace('/leads/mqp');
    });
  }

  setError(error) {
    this.setState({ error });
  }

  refreshLeadDetails(days) {
    if (days === undefined) {
      days = this.state.day;
    }

    if (days === '') {
      days = 14;
      this.setState({day: days});
    }

    this.props.getRecentMqlPlusLeads(days);
  }

  render() {
    const days = ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
      .map(day => (
        <option key={day}>{day}</option>
      ));

    const error = this.state.error
      ? (
        <div className="l-dqf__title">
          <div className="announcement announcement--danger">
            <div className="announcement-text announcement-text--danger">
              {this.state.error}
            </div>
          </div>
        </div>
      )
      : '';

    let purchaseRecent = (
      <div>
        <div className="l-dqf__purchase-title">
        </div>

        <div className="l-dqf__options">
          <div className="l-dqf__option">
            <label className="input-radio">
              <input onChange={() => this.onPurchaseChange(true)} checked={this.state.purchase === true} type="radio" name="purchase" />
              <span className="input-radio__dot" />
              <span>Activate MQL+ leads and purchase leads from the last </span>&nbsp;
              <select onChange={this.onDayChange} value={this.state.day} className="control control--lg control--inline control--select">
                {days}
              </select>&nbsp;
              <span>days</span>
            </label>
          </div>

          <div className="l-dqf__option">
            <label className="input-radio">
              <input onChange={() => this.onPurchaseChange(false)} checked={this.state.purchase === false} type="radio" name="purchase" />
              <span className="input-radio__dot" />
              Activate MQL+ leads without purchasing recent leads
            </label>
          </div>

          <div className="l-dqf__totals">
            <span className="t">{this.props.recent_mql_plus_leads.total_count} x leads</span>&nbsp;
            <span className="t t-muted">{this.props.recent_mql_plus_leads.currency_symbol}</span>&nbsp;
            <span className="t t-bold t-secondary">{this.props.recent_mql_plus_leads.total_price}</span>
          </div>
        </div>
      </div>
    );

    // If there are no leads available to bulk buy disable the recent purchase feature
    if (this.props.mqlPlusLeadCount === 0) {
      purchaseRecent = '';
    }


    return (
      <div className="l-wrapper-container">
        <form onSubmit={this.onSubmit}>
          <div className="l-dqf__title">
            <h2 className="t-dq-title">MQL+ Leads</h2>
          </div>

          {error}

          <div className="l-dqf__targeting l-dqf__card card">
            <div className="l-dqf__card-icon">
              <img alt="" src={targetingIconA} />
            </div>
            <div className="l-dqf__card-content">
              <h3 className="t-dq-section-title">Targeting</h3>

              <p className="t-dq-section-sub">You will receive MQL+ leads based on your current targeting parameters.</p>

              <a href="/lead-targeting" className="l-dqf__targeting-btn btn btn--sm btn--outlined">
                View Targeting
              </a>
            </div>
          </div>

          <div className="l-dqf__budget l-dqf__card card">
            <div className="l-dqf__card-icon">
              <img alt="" src={billingIconA} />
            </div>
            <div className="l-dqf__card-content">
              <h3 className="t-dq-section-title">Budget</h3>

              <p className="t-dq-section-sub">This product will be included in your existing account budget.</p>
            </div>
          </div>

          <div className="l-dqf__volume l-dqf__card card">
            <div className="l-dqf__card-icon">
              <img alt="" src={volumeIcon} />
            </div>
            <div className="l-dqf__card-content">
              <h3 className="t-dq-section-title">Volume</h3>

              <p className="t-dq-section-sub">
                We estimate that you will receive <strong className="t-dq-section-sub__strong">+30% more leads.</strong>
                {this.props.mqlPlusLeadCount === 0 ? '' : ` You can also purchase recent leads below:`}
              </p>

              <div className="l-dqf__volume-divider" />

              {purchaseRecent}
            </div>
          </div>

          <div className="l-dqf__actions">
            <button type="submit" className="btn btn--lg btn--feature">Activate MQL+ Leads</button>
          </div>
        </form>
        <div className="l-footer-container">
          <CmsFooter/>
        </div>
      </div>
    );
  }
}

MqlPlusActivation.propTypes = {
  getRecentMqlPlusLeads: PropTypes.func,
  activateFeature: PropTypes.func,
  purchaseLeads: PropTypes.func,
  leads: PropTypes.array,
  mqlPlusLeadCount: PropTypes.number,
};

MqlPlusActivation.defaultProps = {
  recent_mql_plus_leads: { leads: [], total_price: 0, total_count: 0 },
};

const mapStateToProps = state => ({
  recent_mql_plus_leads: state.recentMqlPlusLeads.data.recent_mql_plus_leads,
});

const mapDispatchToProps = dispatch => ({
  activateFeature: params => dispatch(activateFeature(params)),
  purchaseLeads: params => dispatch(purchaseLeads(params)),
  getRecentMqlPlusLeads: params => dispatch(getRecentMqlPlusLeads(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MqlPlusActivation);
